import Logo from '../../assets/icon.png';

interface LogoIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {

}

export const LogoIcon: React.FC<LogoIconProps> = (props) => {
  return (
    <img src={Logo} style={{
      width: '24px',
      height: '24px',
    }} alt="丰林在线文档平台" {...props} />
  );
};